// extracted by mini-css-extract-plugin
export var numpadContainer = "_na-1";
export var phoneButton = "_na-0";